import { Image, StyleSheet } from 'react-native';
import React from 'react';
import { AppImages } from '@constants/AppImages';
import text from '@styles/text';
import { SpText } from '../../../components/SpText/SpText';
import { SpView } from 'src/components/SpView';
import { useTranslation } from 'react-i18next';
import { testProperties } from '@utils/testProperties';

interface PairedProps {}

export const Paired = ({}: PairedProps) => {
  const { t } = useTranslation();

  return (
    <SpView style={[styles.stepWrapper, styles.center]}>
      <SpView style={{ flexDirection: 'column' }}>
        <SpView style={[{ flex: 1 }, styles.center]}>
          <Image
            style={{ width: 200 }}
            source={AppImages.cdbPaired}
            resizeMode="contain"
            {...testProperties('cdbPairingHousehold', 'image')}
          />
          <SpText style={[text.title, styles.text]}>{t('setup_cdb_paired')}</SpText>
          <SpText style={[text.body, styles.text]}>{t('setup_cdb_paired_lights')}</SpText>
        </SpView>
        <SpView style={styles.btnText}>
          <SpText style={[text.prompt, styles.text]}>{t('setup_cdb_paired_press_continue')}</SpText>
        </SpView>
      </SpView>
    </SpView>
  );
};

const styles = StyleSheet.create({
  stepWrapper: {
    marginTop: '10%',
    marginBottom: 100,
  },
  center: {
    alignItems: 'center',
  },
  text: {
    marginTop: '5%',
  },
  btnText: {
    flex: 1,
    marginTop: 75,
  },
});

export default Paired;
